/*
 * @Author: Teemo Ding
 * @Date: 2022-04-21 11:29:08
 * @LastEditTime: 2022-06-06 14:28:49
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsDetail/Components/Filters/index.tsx
 */
import { Button } from '@/src/components/Antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Filters = ({ disabled, onClick }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //console.log('value', value);
  return (
    <Button type='primary' ghost onClick={onClick} disabled={disabled}>
      {getI18n('general.filters')}
    </Button>
  );
};

export default Filters;
